import { isBarcodeOpenAtom } from '@atoms/barcodeAtoms';
import useOpenBarcode from '@hooks/native/useOpenBarcode';
import { useFlow } from '@router/stackflow';
import { runVibration } from '@utils/nativeUtils';
import { useAtom } from 'jotai';

function useOpenDialog() {
    const { push } = useFlow();
    const [isBarcodeOpen, setIsBarcodeOpen] = useAtom(isBarcodeOpenAtom);

    useOpenBarcode({
        callbackFn: () => {
            const isUseBarcode = window.localStorage.getItem('useBarcode') === 'true';
            if (isUseBarcode && (!isBarcodeOpen)) {
                setIsBarcodeOpen(true);
                push('BarcodeModal', {});
                runVibration();
            }
        },
        deps: [isBarcodeOpen],
    });
}

export default useOpenDialog;
